
import {  Component,FormPageMixins,Mixins,appConst,PageResultModalMixins } from "@/lib";
import LogisticsCost from "@/store/modules/shipment/logisticscost/entity";
import CardTitleView from "@/components/card-title/index.vue"
@Component({
     components:{CardTitleView}
})
export default class DetailLogisticsCostView extends  Mixins(FormPageMixins, PageResultModalMixins) {
     model:LogisticsCost = new LogisticsCost();
     securityItem:any;//选项明细集合（弹框用）
async created() {
            Object.assign(this.config,{
            getAction: "shipment/logisticscost/get",
            pageTitleL:"app.FactoryCost.Registration",
            isRedirectIndex:true

        })
  }
  get record(){
        return this.$store.state.shipment.logisticscost.editLogisticsCost;
    }
    securityColumn = [
        {
            title: this.L('app.LogisticsCost.SerialNumber'),
            slot: 'serialNumber',
            key: 'serialNumber',
            minwidth: 100
          },
          {
            title: this.L('app.LogisticsCost.LogisticsName'),
            slot: 'logisticsName',
            key: 'logisticsName',
            width: 350
          },
          {
                title: this.L("app.LogisticsCost.Amount"),
                key: "amount",
                minWidth: 100,
                align:"right",
                render: (h: any, params: any) => {
                return [h("span", this.$util.format.amount(params.row.amount))];
                },
          },
          {
            title: this.L('app.LogisticsCost.Currency'),
            slot: 'currency',
            key: 'currency',
            minwidth: 100
          },
          {
            title: this.L('app.LogisticsCost.ExchangeRate'),
            slot: 'exchangeRate',
            key: 'exchangeRate',
            render: (h, {row}) => {
                if(row.exchangeRate!=0){
                    if(row.currency==='RMB'){
                        
                        return [h("span", 1)];
                    }
                    else{
                        if(row.ExchangeRate!=0){
                             return [h("span", row.exchangeRate)];
                        }
                        else{
                            return [h("span", row.exchangeRate)];
                        }
                    }
                    
                }
                else{
                    if(row.currency==='RMB'){
                        
                        return [h("span", 1)];
                    }
                    else{
                        if(row.exchangeRate!=0){
                             return [h("span", row.exchangeRate)];
                        }
                        else{
                            return [h("span", "NA")];
                        }
                        
                    }
                     
                }
                
                },
            minwidth: 100
          },
          {
            title: this.L('app.LogisticsCost.InvoiceNumber'),
            slot: 'invoiceNumber',
            key: 'invoiceNumber'
          },
          this.$util.render.dateColumn(
            "app.LogisticsCost.PaymentDate",
            "paymentDate",
            { minWidth: 100 }
          ),
          {
            title: this.L('app.LogisticsCost.Remark'),
            slot: 'remark',
            key: 'remark'
          },
    ];
    get currentUser() {
    return this.$store.state.currentUser.session.user;
  }
   handleSummary ({ columns, data }) {
    const sums = {};
    const totalText = this.L('app.FactoryCost.SubTotal');
    const NA = 'N/A';
    columns.forEach((column, index) => {
        const key = column.key ? column.key : column.slot;
        if (index === 0||index===6 ||index===4||index===5||index===7||index===8 ) {
            sums[key] = {
                key,
                value: ''
            };
            return;
        }
        
        if (index === 1) {
            sums[key] = {
                key,
                value: totalText
            };
            return;
        }
        if (index === 3) {
            sums[key] = {
                key,
                value: 'RMB'
            };
            return;
        }
        var total=0;
        let totalNa=null;
        data.forEach((column, index) => {
            if(column.currency==='USD'){
                total+= column.amount * column.exchangeRate
            }
            else{
                total+=column.amount;
            }
            if(column.exchangeRate===0&&column.currency==='USD'){
                totalNa='NA'
            }
        });
        const values = data.map(item => Number(item[key]));
        if (!values.every(value => isNaN(value))) {
            // const v = values.reduce((prev, curr) => {
            //     const value = Number(curr);
            //     if (!isNaN(value)) {
            //         return prev + curr;
            //     } else {
            //         return prev;
            //     }
            // }, 0);
             if(total>0&&totalNa!='NA'){
                sums[key] = {
                key,
                value: this.$util.format.amount(total)
            };

            }
            else{
                sums[key] = {
                key,
                value:"NA"
            };
            }
        } else {
            sums[key] = {
                key,
                value: NA
            };
        }
    });

    return sums;
  }
}

